function baseURL() {
  return 'https://emglab.vn/QLTS';
}
export default baseURL;
